var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-title-bar"},_vm._l((_vm.titleArray),function(item,index){return _c('div',{key:index,staticClass:"list-title-bar-unit",style:({ width: item.percent })},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }